//external imports
import DescriptionRoundedIcon from '@material-ui/icons/DescriptionRounded';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import { useSelector } from 'react-redux';
import { Button as ChakraButton } from '@chakra-ui/react';

//internal imports
import { useQuery } from 'hooks/useCustomQuery';
import { useNavigate } from 'react-router-dom';
import getCompany from 'API/Company/getCompany';
import walkthroughIds from './walkthroughIds';

const CompanyStatus = () => {
    const { currentCompany } = useSelector((state) => {
        return { ...state.navigationLists };
    });

    const { requiredScope } = useSelector((state) => state.login);

    const navigate = useNavigate();

    const { data: companyStatus } = useQuery({
        queryKey: ['company', currentCompany],
        queryFn: async () => {
            return getCompany(currentCompany);
        },
        enabled: !!currentCompany,
        refetchOnWindowFocus: false,
    });

    if (!companyStatus) {
        return null;
    }

    const showPendingApproval = !companyStatus.approved;

    return (
        <>
            {Object.keys(companyStatus).includes('isActive') &&
                !companyStatus.isActive && (
                    <>
                        <WarningRoundedIcon /> Inactive Company &nbsp;
                    </>
                )}

            {showPendingApproval && requiredScope > 20 && (
                <ChakraButton
                    style={{
                        textTransform: 'none',
                        minHeight: '40px',
                        fontWeight: '400',
                        backgroundColor: 'transparent',
                        color: 'white',
                        borderRadius: '.375rem',
                    }}
                    borderColor="var(--chakra-colors-dark-tcap-borderGray)"
                    _hover={{
                        borderColor: 'gray.300',
                    }}
                    variant="outline"
                    onClick={() => {
                        navigate('/companies', {
                            state: {
                                approval: true,
                                companyData: {
                                    id: currentCompany,
                                    ...companyStatus,
                                },
                            },
                        });
                    }}
                    data-walkthroughid={walkthroughIds.ufPendingApproval}>
                    <WarningRoundedIcon />
                    Pending Approval
                </ChakraButton>
            )}
            {showPendingApproval && requiredScope === 20 && (
                <>
                    <DescriptionRoundedIcon />
                    Pending Approval
                </>
            )}
        </>
    );
};

export default CompanyStatus;
